'use strict';

module.exports = /* @ngInject */ function () {
    return {
        template: '<div ng-show="inventory.items.length && !showInventories"> \
	     				<button type="button" class="btn btn-xs btn-outline-dark" ng-click="showInventory()">' + gettxt.inventory.checkAvailability + ' <span class="label label-{{inventory.availabilityClass}}">{{inventory.quantitySum}}</span></button> \
					</div> \
					<div ng-show="showInventories"> \
						<article-inventory-list></article-inventory-list> \
					</div>'
    }
}
